<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Адреса
      <span v-if="total">({{ total }})</span>
      <router-link class="btn btn-primary" :to="{ name: 'address-add' }">+ Добавить адрес</router-link>
    </h1>

    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>Дата снятия абонплаты</label>
          <el-date-picker
              v-model="bill_datetime"
              input-id="bill-datetime"
              input-class="form-control"
              type="datetime"
              placeholder="Выберите дату и время">
            </el-date-picker>
        </div>
      </div>
      <div class="col-md-3">
        <div class="text-right" style="margin-top: 15px;">
          <a class="red" href="#" @click.prevent="applyBilling">применить снятие абонплаты</a>
        </div>
      </div>
    </div>

    <resource-list
      url="/addresses"
      current-sort="name"
      init-sort-type="asc"
      resource-name="addresses"
      :show-per-page="false"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
      @total="updateTotal"
    />

  </div>
</template>

<script>
import { applyBilling } from '@/services/district.service'
import resourceList from '@/components/ResourceList'

export default {
  name: 'addresses',
  components: { resourceList },
  data () {
    return {
      total: null,
      bill_datetime: null,
      fields: [
        { name: 'name', label: 'Название', sort: true },
        {name: 'buildings_count', label: 'Кол-во домов', sort: false},
        {name: 'blocks_count', label: 'Кол-во подъездов', sort: false},
        {name: 'apartments_count', label: 'Кол-во квартир', sort: false}
      ],
      filters: {
        district: this.$route.params.district_id
      },
      actionRoutes: [
        { name: 'address-details', idName: 'address_id', label: 'Открыть детали' }
      ]
    }
  },
  methods: {
    updateTotal (val) {
      this.total = val
    },
    applyBilling () {
      let billDateTime

      if (this.bill_datetime) {
        billDateTime = this.bill_datetime.toJSON()
      } else {
        billDateTime = this.bill_datetime
      }

      applyBilling(this.filters.district, billDateTime).then((response) => {
        this.showMsg('Снятие абонплаты было успешно проведено!', 'success', 'Успех')
      }).catch(err => {
        console.log(err)
        this.showMsg(err.response.data['non_field_errors'][0], 'error', 'Ошибка')
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// Addresses.vue?35e4a6c0